import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const textAreaTheme: ThemeOptions['components'] = {
  DsTextArea: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiInputBase-root': {
          padding: 0,
          width: 'max-content',
          height: 'max-content',
          '& .MuiInputBase-input': {
            border: 'none',
            padding: '8px',
            borderRadius: tokens.theme.radius.sm,
            boxSizing: 'border-box',
            outline: 'none',
            fontFamily: theme.typography.P16R.fontFamily,
            backgroundColor: tokens.theme.bg.structural.surface,
            '&.DS-disableResize': {
              resize: 'none',
            },
          },
        },

        '.MuiInputBase-sizeSmall .DS-TextArea-adornment-root': {
          fontSize: '16px',
        },

        '.DS-TextArea-adornment-root': {
          color: tokens.theme.fg.structural.secondary,
          position: 'absolute',
          top: 6,
          right: 6,
          fontSize: '20px',
        },
        '&.DS-Input-readOnly': {
          '& .MuiInputBase-input': {
            backgroundColor: tokens.theme.readonly.bg,
          },
        },
      }),
      sm: {
        lineHeight: '18px',
        '& .MuiInputBase-input': {
          paddingRight: '32px',
          fontSize: '12px',
        },
      },
      md: {
        lineHeight: '22px',
        '& .MuiInputBase-input': {
          paddingLeft: '10px',
          paddingRight: '38px',
          fontSize: '14px',
        },
      },
    },
  },
};
